// 网格
import rlBaseData from "./rlBaseData";
import { rlAxisData, rlJointData } from "@/rlMxModules/rlDataClass/index";
import mxcad from "mxcad";
const { McDbLine, McGePoint3d, McCmColor, McDbPolyline } = mxcad;
import { resetRlModules } from "@/mixins/LiteModuleDb.js";
import store from "@/store/index";
import { rlTextData } from "@/rlMxModules/rlDataClass/index";
import { getpickstatus } from "@/api/modelingList.js";
import {
  addEntityToDrawing,
  getEntityData,
  gridLineInsertWith,
  GridIsExist,
  ptOnLine,
  JointIsExist,
  jointIsOnGrid,
  calculateDistanceAndAngle,
} from "@/rlMxModules/operate/operateApi";
class rlGridData extends rlBaseData {
  constructor() {
    super();

    this.m_stJoint = null; // 起点节点
    this.m_edJoint = null; // 终点节点
    this.m_Axis = null; // 关联的轴线
    this.mcDbGrid = new McDbPolyline(); // 关联的cad直线类
    this.mcDbId = null; // 关联的cad直线类图形id

    this.classTypeName = "rlGrid"; // 网格
    this._threeObj = null; // 三维图形对象

    this.m_wallId = null; // 网格上的墙
    this.m_beamId = null; // 网格上的梁
    this.m_slabIds = []; // 网格上的板集合
    this.m_wallHoleId = null; // 网格上的墙洞
    this.m_ringBeamId = null; // 网格上的圈梁
    this.m_partitionWallId = null; // 网格上的隔墙
    this.m_cantiSlabId = null; // 网格上的悬挑板
    // this.m_doorsWindowsId = null; // 网格上的门窗
    this.Color = "#FF0000"; // 构件颜色

    this.m_groupName = "rlLineGridGroup"; // 组名
    this.m_TextObj = null;
    //检查构件文字--临时保存文字
    this.checkText = null;
  }

  // 克隆数据
  myClone() {
    const newObj = new rlGridData();
    newObj.m_stJoint = this.m_stJoint.myClone();
    newObj.m_edJoint = this.m_edJoint.myClone();
    newObj.m_Axis = this.m_Axis;
    newObj.StdFlrGuid = this.StdFlrGuid;
    newObj.mcDbGrid.startPoint = new McGePoint3d(
      newObj.m_stJoint.m_pt[0],
      newObj.m_stJoint.m_pt[1],
      newObj.m_stJoint.m_pt[2]
    );
    newObj.mcDbGrid.endPoint = new McGePoint3d(
      newObj.m_edJoint.m_pt[0],
      newObj.m_edJoint.m_pt[1],
      newObj.m_edJoint.m_pt[2]
    );

    // newObj.mcDbGrid.addVertexAt(
    //   new McGePoint3d(
    //     newObj.m_stJoint.m_pt[0],
    //     newObj.m_stJoint.m_pt[1],
    //     newObj.m_stJoint.m_pt[2]
    //   )
    // );
    // newObj.mcDbGrid.addVertexAt(
    //   new McGePoint3d(
    //     newObj.m_edJoint.m_pt[0],
    //     newObj.m_edJoint.m_pt[1],
    //     newObj.m_edJoint.m_pt[2]
    //   )
    // );
    newObj.mcDbGrid.trueColor = new McCmColor(255, 0, 0);
    newObj.Color = this.Color;
    newObj.mcDbGrid.setxDataString("Guid", newObj.Guid);
    newObj.mcDbGrid.setxDataString("classTypeName", newObj.classTypeName);
    newObj.mcDbGrid.visible = store.state.displayData.gridDisplay;
    return newObj;
  }

  initData(obj) {
    // 合理性校验
    if (!obj.m_stJoint || !obj.m_edJoint) {
      this.erase();
      return;
    }
    super.initData(obj);
    this.m_stJoint = obj.m_stJoint;
    this.m_edJoint = obj.m_edJoint;
    this.m_Axis = obj.m_Axis;

    if (this.mcDbId) {
      this.mcDbGrid = this.mcDbId.getMcDbEntity();
    }
    // 红色
    this.mcDbGrid.trueColor = new McCmColor(255, 0, 0);
    // this.mcDbGrid.startPoint = new McGePoint3d(
    //   this.m_stJoint.m_pt[0],
    //   this.m_stJoint.m_pt[1],
    //   this.m_stJoint.m_pt[2]
    // );
    // this.mcDbGrid.endPoint = new McGePoint3d(
    //   this.m_edJoint.m_pt[0],
    //   this.m_edJoint.m_pt[1],
    //   this.m_edJoint.m_pt[2]
    // );
    let numVerts = this.mcDbGrid.numVerts() - 1;
    for (let i = numVerts; i >= 0; i--) {
      this.mcDbGrid.removeVertexAt(i);
    }

    this.mcDbGrid.addVertexAt(
      new McGePoint3d(
        this.m_stJoint.m_pt[0],
        this.m_stJoint.m_pt[1],
        this.m_stJoint.m_pt[2]
      )
    );
    this.mcDbGrid.addVertexAt(
      new McGePoint3d(
        this.m_edJoint.m_pt[0],
        this.m_edJoint.m_pt[1],
        this.m_edJoint.m_pt[2]
      )
    );

    //

    this.mcDbGrid.setxDataString("Guid", this.Guid);
    this.mcDbGrid.setxDataString("classTypeName", this.classTypeName);
    this.mcDbGrid.visible = store.state.displayData.gridDisplay;
    // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbGrid)

    if (this.m_beamId) {
      const objtmp = getEntityData({
        classTypeName: "rlBeamSeg",
        Guid: this.m_beamId,
      });
      objtmp.isWasmGeted = false;
      objtmp.draw();
      objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
    }

    if (this.m_wallId) {
      const objtmp = getEntityData({
        classTypeName: "rlWallSeg",
        Guid: this.m_wallId,
      });
      objtmp.isWasmGeted = false;
      objtmp.draw();
      objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
    }

    if (this.m_partitionWallId) {
      const objtmp = getEntityData({
        classTypeName: "rlPartitionWallSeg",
        Guid: this.m_partitionWallId,
      });
      objtmp.isWasmGeted = false;
      objtmp.draw();
      objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
    }

    // //增加门窗
    // if (this.m_doorsWindowsId) {
    //   const objtmp = getEntityData({
    //     classTypeName: "rlDoorsWindows",
    //     Guid: this.m_doorsWindowsId,
    //   });
    //   objtmp.isWasmGeted = false;
    //   objtmp.draw();
    //   objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
    // }

    if (this.m_ringBeamId) {
      const objtmp = getEntityData({
        classTypeName: "rlRingBeamSeg",
        Guid: this.m_ringBeamId,
      });
      objtmp.isWasmGeted = false;
      objtmp.draw();
      objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
    }

    if (this.m_wallHoleId) {
      const objtmp = getEntityData({
        classTypeName: "rlWallHole",
        Guid: this.m_wallHoleId,
      });
      objtmp.isWasmGeted = false;
      objtmp.draw();
      objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
    }

    //测试代码
    if (this.m_TextObj) {
      this.m_TextObj?.erase();
      this.drawTextTest();
    }
  }

  draw() {
    //在绘制时处理关联数据
    if (this.m_stJoint) {
      if (!this.m_stJoint.m_gridIds.includes(this.Guid)) {
        this.m_stJoint.m_gridIds.push(this.Guid);
      }
    }

    if (this.m_edJoint) {
      if (!this.m_edJoint.m_gridIds.includes(this.Guid)) {
        this.m_edJoint.m_gridIds.push(this.Guid);
      }
    }

    if (this.m_Axis) {
      if (!this.m_Axis.m_gridIds.includes(this.Guid)) {
        this.m_Axis.m_gridIds.push(this.Guid);
      }
    }

    // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbGrid);
    // this.drawTextTest();
  }

  //绘制检查构件文字
  drawCheckText() {
    if (
      store.state.cadModules.rlProject_detail.businessTypePermission ===
      "investigate"
    ) {
      return;
    }
    let fontSize = store.state.platBtns.fontSize;
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
    let checkStatus = store.state.inspectionStore.checkStatus;
    if (!checkStatus) {
      return;
    }
    let strText = "";
    if (this.m_wallId) {
      let findWall = checkStatus.find((item) => item.guid == this.m_wallId);
      if (findWall) {
        const isShowWall = this.getCheckStatus(6);
        const isCheckCheckText = this.getCheckStatus(25);
        let display = isShowWall && isCheckCheckText;
        if (display && findWall.content != "") {
          strText = "墙(检:" + findWall.content + ")";
        }
      }
    }
    if (this.m_beamId) {
      let findBeam = checkStatus.find((item) => item.guid == this.m_beamId);
      if (findBeam) {
        const objtmp = getEntityData({
          classTypeName: "rlBeamSeg",
          Guid: this.m_beamId,
        });
        if (objtmp) {
          const isShowBeam =
            (this.getCheckStatus(5) &&
              objtmp.Attribute == 1 &&
              objtmp.m_sectParamData.IsRingBeamSeg != 1) ||
            (this.getCheckStatus(8) &&
              objtmp.m_sectParamData.IsRingBeamSeg == 1) || //圈梁
            (this.getCheckStatus(9) && objtmp.Attribute == 2); //次梁
          const isCheckCheckText = this.getCheckStatus(25);
          let display = isShowBeam && isCheckCheckText;
          if (display && findBeam.content != "") {
            if (strText) {
              strText += "/";
            }
            strText += "梁(检:" + findBeam.content + ")";
          }
        }
      }
    }
    let pt1 = new McGePoint3d(...this.m_stJoint.m_pt);
    let pt2 = new McGePoint3d(...this.m_edJoint.m_pt);
    if (strText) {
      let { angle } = calculateDistanceAndAngle(pt1, pt2);
      if (angle == 180) angle = 0;
      if (angle == 270) angle = 90;
      //转换成弧度
      angle = angle * (Math.PI / 180);
      let textObj = new rlTextData();
      let position = new McGePoint3d(
        (pt1.x + pt2.x) / 2,
        (pt1.y + pt2.y) / 2,
        0
      );
      textObj.position = position;
      textObj.Text = strText;
      textObj.fontSize = fontSize;
      textObj.dAngle = angle;
      textObj.textType = "配筋数据文字";
      textObj.McDbText.setxDataString("Guid", this.Guid);
      textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
      textObj.draw(true);
      this.checkText = textObj.mcDbId;
    }
    rlAppObj._rlMx.MxFun.updateDisplay();
    rlAppObj.rlMxDrawObject.updateDisplay();
  }

  //根据guid获取checkbox的点击状态
  getCheckStatus(guid) {
    return store.state.displayData.rlLayerDisplay.includes(guid);
  }

  //删除检查构件文字
  eraseCheckText() {
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
  }

  // 用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_stJoint = getEntityData({
      classTypeName: "rlJoint",
      Guid: obj.m_stJoint,
    });
    this.m_edJoint = getEntityData({
      classTypeName: "rlJoint",
      Guid: obj.m_edJoint,
    });
    this.m_Axis = getEntityData({
      classTypeName: "rlAxis",
      Guid: obj.m_Axis,
    });
    if (!this.m_Axis) {
    }

    if (!this.m_stJoint || !this.m_edJoint) {
      console.log("节点错啦！！！", this.Guid);
    }
    this.mcDbGrid.trueColor = new McCmColor(255, 0, 0);
    this.points = [
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
    ];
    this.mcDbGrid.addVertexAt(
      new McGePoint3d(
        this.m_stJoint.m_pt[0],
        this.m_stJoint.m_pt[1],
        this.m_stJoint.m_pt[2]
      )
    );
    this.mcDbGrid.addVertexAt(
      new McGePoint3d(
        this.m_edJoint.m_pt[0],
        this.m_edJoint.m_pt[1],
        this.m_edJoint.m_pt[2]
      )
    );

    this.mcDbGrid.setxDataString("Guid", this.Guid);
    this.mcDbGrid.setxDataString("classTypeName", this.classTypeName);
    this.mcDbGrid.visible = store.state.displayData.gridDisplay;
    if (this.m_stJoint) {
      if (!this.m_stJoint.m_gridIds.includes(this.Guid)) {
        this.m_stJoint.m_gridIds.push(this.Guid);
      }
    }

    if (this.m_edJoint) {
      if (!this.m_edJoint.m_gridIds.includes(this.Guid)) {
        this.m_edJoint.m_gridIds.push(this.Guid);
      }
    }

    // if (this.m_Axis) {
    //   if (!this.m_Axis.m_gridIds.includes(this.Guid)) {
    //     this.m_Axis.m_gridIds.push(this.Guid);
    //   }
    // }
  }

  saveEditRevokeData() {
    //解除网格与节点的关联
    this.m_stJoint.m_gridIds = this.m_stJoint.m_gridIds.filter(
      (item) => item != this.Guid
    );
    this.m_edJoint.m_gridIds = this.m_edJoint.m_gridIds.filter(
      (item) => item != this.Guid
    );
    //解除网格与轴线的关联
    // this.m_Axis.m_gridIds = this.m_Axis.m_gridIds.filter(
    //   (item) => item != this.Guid
    // );
    super.saveEditRevokeData();
  }

  // 数据修改更新
  updateThisObj(obj, mergeGridObj = null /*与当前网格合并的网格对象*/) {
    if (this.m_stJoint) {
      if (!this.m_stJoint.m_gridIds.includes(this.Guid)) {
        this.m_stJoint.m_gridIds.push(this.Guid);
      }
    }

    if (this.m_edJoint) {
      if (!this.m_edJoint.m_gridIds.includes(this.Guid)) {
        this.m_edJoint.m_gridIds.push(this.Guid);
      }
    }
    // if (this.m_Axis) {
    //   if (!this.m_Axis.m_gridIds.includes(this.Guid)) {
    //     this.m_Axis.m_gridIds.push(this.Guid);
    //   }
    // }

    this.updateData(mergeGridObj);
    super.updateThisObj(obj);
  }

  // 将相关数据更新
  updateData(mergeGridObj = null /*与当前网格合并的网格对象*/) {
    if (this.mcDbId) {
      this.mcDbGrid = this.mcDbId.getMcDbEntity();
      this.mcDbGrid.startPoint = new McGePoint3d(
        this.m_stJoint.m_pt[0],
        this.m_stJoint.m_pt[1],
        this.m_stJoint.m_pt[2]
      );
      this.mcDbGrid.endPoint = new McGePoint3d(
        this.m_edJoint.m_pt[0],
        this.m_edJoint.m_pt[1],
        this.m_edJoint.m_pt[2]
      );
      let numVerts = this.mcDbGrid.numVerts() - 1;
      for (let i = numVerts; i >= 0; i--) {
        this.mcDbGrid.removeVertexAt(i);
      }
      this.mcDbGrid.addVertexAt(this.mcDbGrid.startPoint);
      this.mcDbGrid.addVertexAt(this.mcDbGrid.endPoint);

      //测试代码
      this.m_TextObj?.erase();
      this.drawTextTest();

      // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbGrid);
    }

    if (this.m_beamId) {
      const objtmp = getEntityData({
        classTypeName: "rlBeamSeg",
        Guid: this.m_beamId,
      }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_beamId);

      if (objtmp) {
        objtmp.saveEditRevokeData();
        //添加合并构件
        if (mergeGridObj && mergeGridObj.m_beamId) {
          if (!objtmp.LinkGuids) objtmp.LinkGuids = [];

          objtmp.LinkGuids.push(mergeGridObj.m_beamId);

          let mergeBeamObj = getEntityData({
            classTypeName: "rlBeamSeg",
            Guid: mergeGridObj.m_beamId,
          });
          if (
            mergeBeamObj &&
            mergeBeamObj.LinkGuids &&
            mergeBeamObj.LinkGuids.length
          ) {
            for (
              let index = 0;
              index < mergeBeamObj.LinkGuids.length;
              index++
            ) {
              objtmp.LinkGuids.push(mergeBeamObj.LinkGuids[index]);
            }
          }
        }
        // objtmp.draw();
        // objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
        // objtmp.transformBy(_mat);
        objtmp.updateThisObj(objtmp);
      }
    }
    if (this.m_wallId) {
      const objtmp = getEntityData({
        classTypeName: "rlWallSeg",
        Guid: this.m_wallId,
      }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_wallId);

      if (objtmp) {
        objtmp.saveEditRevokeData();
        //按梁合并
        if (mergeGridObj && mergeGridObj.m_wallId) {
          if (!objtmp.LinkGuids) objtmp.LinkGuids = [];
          objtmp.LinkGuids.push(mergeGridObj.m_wallId);
          let mergeWallObj = getEntityData({
            classTypeName: "rlWallSeg",
            Guid: mergeGridObj.m_wallId,
          });
          if (
            mergeWallObj &&
            mergeWallObj.LinkGuids &&
            mergeWallObj.LinkGuids.length
          ) {
            for (
              let index = 0;
              index < mergeWallObj.LinkGuids.length;
              index++
            ) {
              objtmp.LinkGuids.push(mergeWallObj.LinkGuids[index]);
            }
          }
        }
        // objtmp.draw();
        // objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
        // objtmp.transformBy(_mat);
        objtmp.updateThisObj(objtmp);
      }
    }
    if (this.m_partitionWallId) {
      const objtmp = getEntityData({
        classTypeName: "rlPartitionWallSeg",
        Guid: this.m_partitionWallId,
      }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_partitionWallId);

      if (objtmp) {
        objtmp.saveEditRevokeData();
        // objtmp.draw();
        // objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
        // objtmp.transformBy(_mat);
        objtmp.updateThisObj(objtmp);
      }
    }
    if (this.m_ringBeamId) {
      const objtmp = getEntityData({
        classTypeName: "rlRingBeamSeg",
        Guid: this.m_ringBeamId,
      }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_ringBeamId);

      if (objtmp) {
        objtmp.saveEditRevokeData();
        // objtmp.draw();
        // objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
        // objtmp.transformBy(_mat);
        objtmp.updateThisObj(objtmp);
      }
    }
    // if (this.m_wallHoleId) {
    //   const objtmp = getEntityData({
    //     classTypeName: "rlWallHole",
    //     Guid: this.m_wallHoleId,
    //   }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_wallHoleId);

    //   if (objtmp) {
    //     // objtmp.draw();
    //     // objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
    //     // objtmp.transformBy(_mat);
    //     objtmp.updateThisObj(objtmp);
    //   }
    // }
    // if (this.m_doorsWindowsId) {
    //   const objtmp = getEntityData({
    //     classTypeName: "rlDoorsWindows",
    //     Guid: this.m_doorsWindowsId,
    //   });
    //   if (objtmp) {
    //     objtmp.updateThisObj(objtmp);
    //   }
    // }
  }

  drawTextTest() {
    return;
    this.m_TextObj = new rlTextData();
    let position = new THREE.Vector3().lerpVectors(
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
      0.5
    );
    position.x -= 120;
    position.y -= 120;
    this.m_TextObj.position = position;
    // new THREE.Vector3(...this.m_pt);
    // this.m_TextObj.Text = this.Guid.slice(-5);
    let stPt = new THREE.Vector3(...this.m_stJoint.m_pt);
    let edPt = new THREE.Vector3(...this.m_edJoint.m_pt);
    let dist = stPt.distanceTo(edPt);
    this.m_TextObj.Text = this.Guid.slice(-5);
    this.m_TextObj.textType = "草图网格长度";
    this.m_TextObj.draw(true);
    this.m_TextObj.lineObjId = this.m_TextObj.mcDbId;
  }

  //移动网格：删除原网格，重新布置网格
  async transformBy(vecMove) {
    // 移动点位置
    const sPt = new THREE.Vector3(...this.m_stJoint.m_pt).add(vecMove);
    const ePt = new THREE.Vector3(...this.m_edJoint.m_pt).add(vecMove);

    //检查新的位置是否已存在网格，若已存在，不能移动
    const rlGridGroup = store.state.rlEntData.totalEntityData["rlGrid"];
    if (rlGridGroup && rlGridGroup.length) {
      for (let i = 0; i < rlGridGroup.length; i++) {
        const item = rlGridGroup[i];
        let stTmp = new THREE.Vector3(...item.m_stJoint.m_pt);
        let edTmp = new THREE.Vector3(...item.m_edJoint.m_pt);
        //在新的网格线上已存在网格
        if (ptOnLine(sPt, ePt, stTmp) > 0 && ptOnLine(sPt, ePt, edTmp) > 0) {
          return false;
        }
      }
    }

    let moveStPt = false; //起点是否可移动
    let addStJoint = null; //新增的起点节点
    //判断节点关联数据，确认是否可移动
    if (this.m_stJoint.m_cloumId || this.m_stJoint.m_gridIds.length > 3) {
      //不能移动，需要复制
    } else if (this.m_stJoint.m_gridIds.length == 3) {
      //计算另外网格是否共线
      let guid1 =
        this.m_stJoint.m_gridIds[0] == this.Guid
          ? this.m_stJoint.m_gridIds[1]
          : this.m_stJoint.m_gridIds[0];
      let guid2 =
        this.m_stJoint.m_gridIds[2] == this.Guid
          ? this.m_stJoint.m_gridIds[1]
          : this.m_stJoint.m_gridIds[2];
      //判断是否在两个网格共线
      let objtmp1 = getEntityData({
        classTypeName: "rlGrid",
        Guid: guid1,
      });
      let objtmp2 = getEntityData({
        classTypeName: "rlGrid",
        Guid: guid2,
      });

      //若共线,当前节点删除，新增一个节点
      if (objtmp1 && objtmp2 && objtmp1.m_Axis.Guid === objtmp2.m_Axis.Guid) {
        // 删除当前节点--只能删除，不能移动，因为不确定新节点是否在当前网格上
        await this.m_stJoint.erase();
        // moveStPt = true;
      } else {
        //否则，不能移动，需要复制
      }
    } else if (this.m_stJoint.m_gridIds.length == 2) {
      //节点在其他网格上，不能移动，需要复制
    } else {
      moveStPt = true;
    }

    let moveEdPt = false; //终点是否可移动
    let addEdJoint = null; //新增的终点节点
    //判断节点关联数据，确认是否可移动
    if (this.m_edJoint.m_cloumId || this.m_edJoint.m_gridIds.length > 3) {
      //不能移动，需要复制
    } else if (this.m_edJoint.m_gridIds.length == 3) {
      //计算另外网格是否共线
      let guid1 =
        this.m_edJoint.m_gridIds[0] == this.Guid
          ? this.m_edJoint.m_gridIds[1]
          : this.m_edJoint.m_gridIds[0];
      let guid2 =
        this.m_edJoint.m_gridIds[2] == this.Guid
          ? this.m_edJoint.m_gridIds[1]
          : this.m_edJoint.m_gridIds[2];
      //判断是否在两个网格共线
      let objtmp1 = getEntityData({
        classTypeName: "rlGrid",
        Guid: guid1,
      });
      let objtmp2 = getEntityData({
        classTypeName: "rlGrid",
        Guid: guid2,
      });

      //若共线,当前节点删除，新增一个节点
      if (objtmp1 && objtmp2 && objtmp1.m_Axis.Guid === objtmp2.m_Axis.Guid) {
        // 删除当前节点--只能删除，不能移动，因为不确定新节点是否在当前网格上
        await this.m_edJoint.erase();
        // moveEdPt = true;
      } else {
        //否则，不能移动，需要复制
      }
    } else if (this.m_edJoint.m_gridIds.length == 2) {
      //节点在其他网格上，不能移动，需要复制
    } else {
      moveEdPt = true;
    }

    await this.saveEditRevokeData();
    if (moveStPt) {
      //判断节点是否存在
      let isEditSP = JointIsExist(sPt.toArray());
      if (isEditSP) {
        //删除当前节点
        await this.m_stJoint.erase();
        this.m_stJoint = isEditSP;
      } else {
        await this.m_stJoint.saveEditRevokeData();
        this.m_stJoint.m_pt = sPt.toArray();
        await this.m_stJoint.updateThisObj(this.m_stJoint, false);

        //判断节点移动后是否在网格上，若在，分割此网格
        await jointIsOnGrid(this.m_stJoint);
      }
    } else {
      //新增一个节点
      let newStJoint = new rlJointData();
      newStJoint.initData({ m_pt: sPt.toArray() });

      let isEditSP = await addEntityToDrawing(newStJoint, false);
      if (!isEditSP) isEditSP = newStJoint;
      addStJoint = isEditSP;
    }

    if (moveEdPt) {
      //判断节点是否存在
      if (JointIsExist(ePt.toArray())) {
        //删除当前节点
        let isEditEP = JointIsExist(ePt.toArray());
        if (isEditEP) {
          //删除当前节点
          await this.m_edJoint.erase();
          this.m_edJoint = isEditEP;
        }
      } else {
        await this.m_edJoint.saveEditRevokeData();
        this.m_edJoint.m_pt = ePt.toArray();
        await this.m_edJoint.updateThisObj(this.m_edJoint, false);

        //判断节点移动后是否在网格上，若在，分割此网格
        await jointIsOnGrid(this.m_edJoint);
      }
    } else {
      //新增一个节点
      let newEdJoint = new rlJointData();
      newEdJoint.initData({ m_pt: ePt.toArray() });

      let isEditEP = await addEntityToDrawing(newEdJoint, false);
      if (!isEditEP) isEditEP = newEdJoint;
      addEdJoint = isEditEP;
    }

    if (!moveEdPt || !moveStPt) {
      if (!moveStPt && addStJoint) {
        this.m_stJoint = addStJoint;
      }

      if (!moveEdPt && addEdJoint) {
        this.m_edJoint = addEdJoint;
      }
    }

    //若当前轴线无关联网格，则删除轴线
    this.m_Axis.m_gridIds = this.m_Axis.m_gridIds.filter(
      (item) => item != this.Guid
    );

    if (this.m_Axis.m_gridIds.length == 0) await this.m_Axis.erase();

    //创建轴线
    let axisObj = new rlAxisData();
    axisObj.initData({
      m_stJoint: this.m_stJoint,
      m_edJoint: this.m_edJoint,
    });
    let isExistAxis = await addEntityToDrawing(axisObj, false);
    if (isExistAxis) axisObj = isExistAxis;

    this.m_Axis = axisObj;
    await this.updateThisObj(this);

    return;
    //--------以下弃用
    //将节点上的构件复制出来
    // let newStCloumn = null;
    // if (this.m_stJoint.m_cloumId) {
    //   const objtmp = getEntityData({
    //     Guid: this.m_stJoint.m_cloumId,
    //     classTypeName: "rlColSeg",
    //   });
    //   if (objtmp) {
    //     newStCloumn = new rlJointData();
    //     newStCloumn.initData({ m_pt: objtmp.m_pt });
    //   }
    //   await objtmp.erase();
    // }

    // let newEdCloumn = null;
    // if (this.m_edJoint.m_cloumId) {
    //   const objtmp = getEntityData({
    //     Guid: this.m_edJoint.m_cloumId,
    //     classTypeName: "rlColSeg",
    //   });
    //   if (objtmp) {
    //     newEdCloumn = new rlJointData();
    //     newEdCloumn.initData({ m_pt: objtmp.m_pt });
    //   }
    //   await objtmp.erase();
    // }

    // //记录网格上的构件及对应的截面
    // let beamGuid = this.m_beamId;
    // let wallGuid = this.m_wallId;
    // let ringBeamGuid = this.m_ringBeamId;
    // let wallHoleGuid = this.m_wallHoleId;

    // //删除原有网格
    // await this.erase();

    // //添加新的网格
    // //1.创建节点--起点
    // let newStJoint = new rlJointData();
    // newStJoint.initData({ m_pt: sPt.toArray() });

    // let isEditSP = await addEntityToDrawing(newStJoint, false);
    // if (!isEditSP) isEditSP = newStJoint;
    // //1.构件与起点节点绑定
    // if (newStCloumn) {
    //   newStCloumn.m_JointData = isEditSP;
    //   newStCloumn.draw();
    //   await addEntityToDrawing(newStCloumn, false);
    // }
    // //1.创建节点--终点
    // let newEdJoint = new rlJointData();
    // newEdJoint.initData({ m_pt: ePt.toArray() });

    // let isEditEP = await addEntityToDrawing(newEdJoint, false);
    // if (!isEditEP) isEditEP = newEdJoint;
    // //1.构件与终点节点绑定
    // if (newEdCloumn) {
    //   newEdCloumn.m_JointData = isEditEP;
    //   newEdCloumn.draw();
    //   await addEntityToDrawing(newEdCloumn, false);
    // }
    // //2.创建轴线
    // let axisObj = new rlAxisData();
    // axisObj.initData({
    //   m_stJoint: isEditSP,
    //   m_edJoint: isEditEP,
    // });
    // let isExistAxis = await addEntityToDrawing(axisObj, false);
    // if (isExistAxis) axisObj = isExistAxis;

    // //3.创建网格
    // let newGrid = new rlGridData();
    // newGrid.initData({
    //   m_stJoint: isEditSP,
    //   m_edJoint: isEditEP,
    //   m_Axis: axisObj,
    // });
    // //将网格上的构件重新绑定
    // newGrid.m_beamId = beamGuid;
    // newGrid.m_wallId = wallGuid;
    // newGrid.m_ringBeamId = ringBeamGuid;
    // newGrid.m_wallHoleId = wallHoleGuid;
    // await addEntityToDrawing(newGrid, false);
  }

  //网格复制
  async copyGridData(vecMove) {
    let entityClone = this.myClone();
    // 复制节点
    const newStJoint = entityClone.m_stJoint;
    const newEdJoint = entityClone.m_edJoint;

    // 移动点位置
    const sPt = new THREE.Vector3(...newStJoint.m_pt).add(vecMove).toArray();
    newStJoint.initData({ m_pt: sPt });

    const ePt = new THREE.Vector3(...newEdJoint.m_pt).add(vecMove).toArray();
    newEdJoint.initData({ m_pt: ePt });

    // 给网格绑定新的克隆点
    entityClone.m_stJoint = newStJoint;
    entityClone.m_edJoint = newEdJoint;

    // newStJoint.m_gridIds.push(entityClone.Guid);
    // newEdJoint.m_gridIds.push(entityClone.Guid);
    // 返回已存在的节点对象
    const isEditSP = await addEntityToDrawing(entityClone.m_stJoint, false);
    const isEditEP = await addEntityToDrawing(entityClone.m_edJoint, false);

    let isExist = false;
    if (isEditSP && isEditEP) {
      // 校验是否已存在网格，若存在，不允许移动
      let isExistGrid = GridIsExist(entityClone);
      if (isExistGrid) {
        isExist = true;
        return false;
      }
    }

    if (isExist) {
      return false; // 复制处已存在网格
    }
    // 判断节点是否重复，修改绑定关系
    if (isEditSP) {
      entityClone.m_stJoint = isEditSP;
      // if (!entityClone.m_stJoint.m_gridIds.includes(entityClone.Guid)) {
      //   entityClone.m_stJoint.m_gridIds.push(entityClone.Guid);
      // }
    }
    // 判断节点是否重复，修改绑定关系
    if (isEditEP) {
      entityClone.m_edJoint = isEditEP;
      // if (!entityClone.m_edJoint.m_gridIds.includes(entityClone.Guid)) {
      //   entityClone.m_edJoint.m_gridIds.push(entityClone.Guid);
      // }
    }

    // 判断移动后的网格位置上是否存在轴线，若没有，新增轴线，内部已实现重复校验
    // let axisObj = null;
    // entityClone.m_Axis.m_gridIds = entityClone.m_Axis.m_gridIds.filter(
    //   (item) => item != entityClone.Guid
    // );

    // axisObj = new rlAxisData();
    // axisObj.initData({
    //   m_stJoint: isEditSP || newStJoint,
    //   m_edJoint: isEditEP || newEdJoint,
    // });
    // let isExistAxis = await addEntityToDrawing(axisObj, false);
    // if (isExistAxis) axisObj = isExistAxis;

    entityClone.initData({
      m_stJoint: entityClone.m_stJoint,
      m_edJoint: entityClone.m_edJoint,
      m_Axis: null,
    });

    //需求约定：不需要复制构件

    await addEntityToDrawing(entityClone, false);
    return entityClone;
  }

  // 返回图形源数据
  getDataBase() {
    const data = super.getDataBase();
    if (this.m_stJoint && this.m_stJoint.Guid != "")
      data["Jt1Guid"] = this.m_stJoint.Guid;

    if (this.m_edJoint && this.m_edJoint.Guid != "")
      data["Jt2Guid"] = this.m_edJoint.Guid;

    if (this.m_Axis && this.m_Axis.Guid) data["AxisGuid"] = this.m_Axis.Guid;
    else data["AxisGuid"] = "";

    return data;
  }

  erase(foreceErase = false /* 是否强制删除 */) {
    //撤销回退中不处理关联处理
    if (!store.state.globalData.isReDo) {
      // 删除网格上的梁
      if (this.m_beamId) {
        const objtmp = getEntityData({
          classTypeName: "rlBeamSeg",
          Guid: this.m_beamId,
        }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_beamId);
        if (objtmp) {
          if (foreceErase) {
            objtmp.erase();
          } else {
            return; //存在关联的内容，不能删
          }
        }
      }

      if (this.m_ringBeamId) {
        const objtmp = getEntityData({
          classTypeName: "rlRingBeamSeg",
          Guid: this.m_ringBeamId,
        }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_ringBeamId);

        if (objtmp) {
          if (foreceErase) {
            objtmp.erase();
          } else {
            return; //存在关联的内容，不能删
          }
        }
      }
      // if (this.m_wallHoleId) {
      //   const objtmp = getEntityData({
      //     classTypeName: "rlWallHole",
      //     Guid: this.m_wallHoleId,
      //   }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_wallHoleId);

      //   if (objtmp)
      //     if (objtmp) {
      //       if (foreceErase) {
      //         objtmp.erase();
      //       } else {
      //         return; //存在关联的内容，不能删
      //       }
      //     }
      // }
      // 删除网格上的墙
      if (this.m_wallId) {
        const objtmp = getEntityData({
          classTypeName: "rlWallSeg",
          Guid: this.m_wallId,
        }); //  rlAppObj.rlMxDrawObject.getMxEntity(this.m_wallId);
        if (objtmp)
          if (objtmp) {
            if (foreceErase) {
              objtmp.erase();
            } else {
              return; //存在关联的内容，不能删
            }
          }
      }
      // 删除网格上的隔墙
      if (this.m_partitionWallId) {
        const objtmp = getEntityData({
          classTypeName: "rlPartitionWallSeg",
          Guid: this.m_partitionWallId,
        }); //  rlAppObj.rlMxDrawObject.getMxEntity(this.m_partitionWallId);
        if (objtmp)
          if (objtmp) {
            if (foreceErase) {
              objtmp.erase();
            } else {
              return; //存在关联的内容，不能删
            }
          }
      }
      // if (this.m_doorsWindowsId) {
      //   const objtmp = getEntityData({
      //     classTypeName: "rlDoorsWindows",
      //     Guid: this.m_doorsWindowsId,
      //   }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_doorsWindowsId);

      //   if (objtmp)
      //     if (objtmp) {
      //       if (foreceErase) {
      //         objtmp.erase();
      //       } else {
      //         return; //存在关联的内容，不能删
      //       }
      //     }
      // }
    }

    // 删除与节点之间的关联
    if (this.m_stJoint) {
      this.m_stJoint.m_gridIds = this.m_stJoint.m_gridIds.filter(
        (item) => item != this.Guid
      );
      //撤销回退中不处理关联处理
      if (!store.state.globalData.isReDo) {
        // if (this.m_stJoint.m_gridIds.length < 1) this.m_stJoint.erase();
        if (this.m_stJoint && this.m_stJoint.m_cloumId == null) {
          if (this.m_stJoint.m_gridIds.length == 0) {
            this.m_stJoint.erase();
          }
          // else if (this.m_stJoint.m_gridIds.length == 2) {
          //   let obj1 = getEntityData({
          //     Guid: this.m_stJoint.m_gridIds[0],
          //     classTypeName: "rlGrid",
          //   });
          //   let obj2 = getEntityData({
          //     Guid: this.m_stJoint.m_gridIds[1],
          //     classTypeName: "rlGrid",
          //   });
          //   //判断网格是否共线，若共线，删除节点
          //   if (obj1 && obj2 && obj1.m_Axis.Guid === obj2.m_Axis.Guid) {
          //     this.m_stJoint.erase();
          //   }
          // }
        }
      }
    }

    if (this.m_edJoint) {
      this.m_edJoint.m_gridIds = this.m_edJoint.m_gridIds.filter(
        (item) => item != this.Guid
      );

      //在撤销回退中，不删除孤立节点
      if (!store.state.globalData.isReDo) {
        // if (this.m_edJoint.m_gridIds.length < 1) this.m_edJoint.erase();
        if (this.m_edJoint && this.m_edJoint.m_cloumId == null) {
          if (this.m_edJoint.m_gridIds == 0) {
            this.m_edJoint.erase();
          }
          // else if (this.m_edJoint.m_gridIds.length == 2) {
          //   let obj1 = getEntityData({
          //     Guid: this.m_edJoint.m_gridIds[0],
          //     classTypeName: "rlGrid",
          //   });
          //   let obj2 = getEntityData({
          //     Guid: this.m_edJoint.m_gridIds[1],
          //     classTypeName: "rlGrid",
          //   });

          //   //判断网格是否共线，若共线，删除节点
          //   if (obj1 && obj2 && obj1.m_Axis.Guid === obj2.m_Axis.Guid) {
          //     this.m_edJoint.erase();
          //   }
          // }
        }
      }
    }
    this.eraseCheckText();
    this.mcDbGrid?.erase();
    this.mcDbId?.getMcDbEntity().erase();
    super.erase();
    this.m_TextObj?.erase();
  }
  getDrawData() {
    const data = super.getDrawData();

    // data["Color"] = new THREE.Color(0xff0000);
    data["m_stJoint"] = this.m_stJoint.Guid;
    data["m_edJoint"] = this.m_edJoint.Guid;
    data["m_Axis"] = this.m_Axis ? this.m_Axis.Guid : "";
    data["m_wallId"] = this.m_wallId;
    data["m_partitionWallId"] = this.m_partitionWallId;
    // data["m_doorsWindowsId"] = this.m_doorsWindowsId;
    data["m_beamId"] = this.m_beamId;
    data["m_slabIds"] = this.m_slabIds;
    data["m_wallHoleId"] = this.m_wallHoleId;
    data["m_ringBeamId"] = this.m_ringBeamId;
    return data;
  }
}

export { rlGridData };
